window.onload = (event) => {
    const searchElement = document.getElementById('search-dialog')
    const searchDialog = new A11yDialog(searchElement)
};